import { type FC } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

export type SplashPageRendererProps = {
  /**
   * Application version to display on the splash screen.
   */
  version: string;
};

export const SplashPageRenderer: FC<SplashPageRendererProps> = ({
  version,
}) => (
  <CenteredLayout vertical horizontal>
    <Stack spacing={1} alignItems="center">
      <img
        src="https://placehold.co/256x256/dddddd/999999"
        alt="JOBI Data Collection App Logo"
        style={{ display: 'flex' }}
      />
      <Typography variant="h5">JOBI Data Collection</Typography>
      <Typography variant="h6">{version}</Typography>
      <Box sx={{ py: 8 }}>
        <CircularProgress />
      </Box>
    </Stack>
  </CenteredLayout>
);
